package com.tencent.kuikly.h5app.module

import com.tencent.kuikly.core.render.web.export.KuiklyRenderBaseModule
import com.tencent.kuikly.core.render.web.ktx.KuiklyRenderCallback
import com.tencent.kuikly.core.render.web.nvi.serialization.json.JSONObject
import org.w3c.dom.CloseEvent
import org.w3c.dom.MessageEvent
import org.w3c.dom.WebSocket

class KRWebSocketModule : KuiklyRenderBaseModule() {
    private var socket: WebSocket? = null
    private var eventCallback: KuiklyRenderCallback? = null
    private var generation = 0

    override fun call(method: String, params: String?, callback: KuiklyRenderCallback?): Any? {
        val json = params?.takeIf { it.isNotBlank() }?.let(::JSONObject) ?: JSONObject()
        return when (method) {
            "connect" -> connect(json.optString("url"), callback)
            "disconnect" -> disconnect(json.optInt("code", 1000), json.optString("reason"))
            else -> null
        }
    }

    private fun connect(url: String, callback: KuiklyRenderCallback?) {
        disconnect(1000, "Reconnecting")
        val currentGeneration = ++generation
        eventCallback = callback
        val current = WebSocket(url)
        socket = current
        current.onopen = {
            if (currentGeneration == generation) notify("connected")
        }
        current.onmessage = { event ->
            if (currentGeneration == generation) {
                notify("message", (event as MessageEvent).data?.toString().orEmpty())
            }
        }
        current.onerror = {
            if (currentGeneration == generation) notify("error", "WebSocket connection failed")
        }
        current.onclose = { event ->
            if (currentGeneration == generation) {
                val close = event as CloseEvent
                notify(
                    "disconnected",
                    JSONObject().apply {
                        put("code", close.code.toInt())
                        put("reason", close.reason)
                    }.toString(),
                )
            }
        }
    }

    private fun disconnect(code: Int, reason: String) {
        generation++
        val current = socket
        socket = null
        eventCallback = null
        runCatching { current?.close(code.toShort(), reason) }
    }

    private fun notify(type: String, data: String = "") {
        eventCallback?.invoke(
            JSONObject().apply {
                put("type", type)
                put("data", data)
            }.toString()
        )
    }

    companion object {
        const val MODULE_NAME = "KRWebSocketModule"
    }
}
